import { handleActions } from 'redux-actions'

import { actions } from '../actions/settings'
import { defaultLanguage } from '../../helpers/languages'

const defaultState = {
    language: defaultLanguage,
    timezone: undefined
}

const resetSettings = (_state, _action) => {
    return defaultState
}

const setLanguage = (state, action) => {
    return { ...state, language: action.payload }
}

const setTimezone = (state, action) => {
    return { ...state, timezone: action.payload }
}

export default handleActions({
    [actions.resetSettings]: resetSettings,
    [actions.setLanguage]: setLanguage,
    [actions.setTimezone]: setTimezone
}, defaultState)



// WEBPACK FOOTER //
// ./src/store/reducers/settings.js